// extracted by css-extract-rspack-plugin
export default {"container":"MermaidPreview-module__container__neSRn"};